const actions = {

    FETCH_CHANGED_PERMISSIONS: 'FETCH_CHANGED_PERMISSIONS',
    fetchChangedPermissionAction: (data) => ({
        type: actions.FETCH_CHANGED_PERMISSIONS,
        data
    }),
};

export default actions;
